import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'

const slice = createSlice({
  name: 'companyAnalysis/peerAnalysis',
  initialState: {
    peerOrganizationIds: [],
  },
  reducers: {
    changePeerOrganizationIds: (state, action) => {
      state.peerOrganizationIds = action.payload
    },
  },
})

export const selectPeerOrganizationIds = (state) =>
  state[slice.name].peerOrganizationIds

export const { changePeerOrganizationIds } = slice.actions

register(slice.name, slice.reducer)
